import { createClient } from "@wix/sdk";
import { site } from "@wix/site";
import { ecom } from "@wix/site-ecom";
import { currentCart } from "@wix/ecom";
import Splide from "@splidejs/splide"

let cartSubtotal = 0;
let currentPage = "";
let cartCurrency = "";
let sideCartIsOpen = false;
let upsellProducts: any = [];
let canFunction = true;
let appInstanceChecked = false;
const settings = window.monsterplugins && window.monsterplugins.freeShippingProgress ? window.monsterplugins.freeShippingProgress : null;
const PLUGIN_CLASS_PREFIX = "mp-freeshipping-progress-bar_";

const prepareStyle = () => {
    try {
        const style = window.monsterplugins.freeShippingProgress;
        const gradientBg = `linear-gradient(${style.gradientAngle}deg,${style.backgroundColorOne},${style.backgroundColorTwo})`;
        const css = `
.mp-freeshipping-progress-bar {
    margin: 20px 0;
    padding: 20px;
    min-height: 30px;
    height: auto !important;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    border: ${style.borderWidth}px solid ${style.borderColor};
    border-radius: ${style.borderRadius}px;
    background: ${style.backgroundStyle === "solid" ? style.backgroundColorOne : gradientBg};
    font-family: Helvetica;
}

.sideCart .mp-freeshipping-progress-bar {
    margin: 20px;
}

.mp-freeshipping-progress-bar_text-indicator{
    font-size: ${style.messageFontSize}px;
    color: ${style.messageFontColor};
    font-weight: bold;
    margin-bottom: 16px;
}

.mp-freeshipping-progress-bar_bar-container {
    width: 100%;
    position: relative;
    height: 100%;
}

.mp-freeshipping-progress-bar .mp-freeshipping-progress-bar_bar-background {
    background: ${style.barBackgroundColor};
}

.mp-freeshipping-progress-bar_bar-background {
    width: 100%;
}

.mp-freeshipping-progress-bar_bar-background,
.mp-freeshipping-progress-bar_bar-foreground {
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
}

.mp-freeshipping-progress-bar .mp-freeshipping-progress-bar_bar-foreground {
    background: ${style.barForegroundColor};
}

.mp-freeshipping-progress-bar .mp-freeshipping-progress-bar_bar-background,
.mp-freeshipping-progress-bar .mp-freeshipping-progress-bar_bar-foreground {
    border-radius: ${style.barRadius}px;
    height: 8px;
}

.mp-freeshipping-progress-bar .mp-freeshipping-progress-bar_bar-foreground {
    transition: width .5s ease-in-out;
}

.mp-freeshipping-progress-bar_bar-background,
.mp-freeshipping-progress-bar_bar-foreground {
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
}

.mp-freeshipping-progress-bar_upsell-products {
    width: 100%;
}

.mp-freeshipping-progress-bar_upsell-products li {
    display: flex;
    gap: 8px;
    padding: 0 36px;
}

.mp-freeshipping-progress-bar_main-img img {
    width: 64px;
    border-radius: ${style.buttonBorderRadius}px;
}

.mp-freeshipping-progress-bar_upsell-products{
    margin-top: 18px;
}

.mp-freeshipping-progress-bar_product-info {
    flex-grow: 1;
    overflow: hidden;
}

.mp-freeshipping-progress-bar_product-title a {
    font-size: ${style.productTitleSize}px;
    color: ${style.productTitleColor};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.mp-freeshipping-progress-bar_product-price {
    font-size: ${style.productPriceSize}px;
    color: ${style.productPriceColor};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.mp-freeshipping-progress-bar_add-to-cart-btn {
    align-self: center;
}

.mp-freeshipping-progress-bar_add-to-cart-btn button{
    background: transparent;
    min-height: 36px;
}

.mp-freeshipping-progress-bar_add-to-cart-btn button{
    border: ${style.buttonBorderSize}px solid ${style.buttonBorderColor};
    border-radius: ${style.buttonBorderRadius}px;
    background: ${style.buttonFillColor ? style.buttonFillColor : "transparent"};
    font-size: ${style.buttonTextSize}px;
    color: ${style.buttonTextColor};
    cursor: pointer;
    padding: 8px;
}

.mp-freeshipping-progress-bar button.splide__arrow {
    background: none;
    opacity: unset;
}

.mp-freeshipping-progress-bar button.splide__arrow svg{
    fill: ${style.arrowColor};
}

.mp-freeshipping-progress-bar .splide__arrow--next {
    right: 0em;
}

.mp-freeshipping-progress-bar .splide__arrow--prev {
    left: 0em;
}

.mp-freeshipping-progress-bar_loader {
  border: 2px solid ${style.barBackgroundColor};
  border-radius: 50%;
  border-top: 2px solid ${style.barForegroundColor};
  width: 14px;
  height: 14px;
  margin: auto;
  -webkit-animation: mp-spin 2s linear infinite;
  animation: mp-spin 2s linear infinite;
}

@-webkit-keyframes mp-spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes mp-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;
        const styleElement = document.createElement('style');
        const head = document.head || document.getElementsByTagName('head')[0];
        head.appendChild(styleElement);
        styleElement.appendChild(document.createTextNode(css));
    }
    catch (err) {
        console.error(err);
        console.log("Unable prepare shipping bar style");
    }
}

const getCart = async () => {
    try {
        if (!appInstanceChecked) {
            await getAppInstance();
        }
        if (canFunction) {
            const cart = await wixClient.currentCart.getCurrentCart();
            cartCurrency = cart.currency;
            if (cart && cart.subtotal && cart.subtotal.amount) {
                cartSubtotal = parseFloat(cart.subtotal.amount);
            }
            else {
                cartSubtotal = 0;
            }
            if (settings) {
                if (cartSubtotal < settings.threshold) {
                    displayFreeShippingBar();
                    if (settings.displayUpsellProducts) {
                        getRecommendations(cart);
                    }
                }
                else {
                    displayFreeShippingBar();
                    hideUpsellProducts();
                }
            }
        }
    } catch (error) {
        console.log(error);
    }
};

const getRecommendations = async (cart: currentCart.Cart) => {
    try {
        if (cart.lineItems) {
            const cartItems = cart.lineItems.map(i => i.catalogReference?.catalogItemId);
            const res = await wixClient.fetchWithAuth(`${settings.apiUrl}/recommendations-api?items=${cartItems.join(",")}`);
            const data = await res.json();
            upsellProducts = data;
            displayUpsellProducts();
        }
    }
    catch (err) {
        console.error(err);
    }
}

const addToCart = async (itemId: string) => {
    try {
        await wixClient.currentCart.addToCurrentCart({ lineItems: [{ quantity: 1, catalogReference: { appId: "215238eb-22a5-4c36-9e7b-e7c08025e04e", catalogItemId: itemId } }] });
        await wixClient.ecom.refreshCart();
    }
    catch (err) {
        console.error(err);
    }
}

const displayFreeShippingBar = () => {
    if (sideCartIsOpen && settings.visibleOnSideCart) {
        displayFreeShippingElement("mp-free-shipping-progress-side-cart", "main[data-hook='SideCartAppDataHook.root'] [data-hook='CartItemsDataHook.root']");
    }

    if (currentPage === "CartPage" && settings.visibleOnCartPage) {
        displayFreeShippingElement("mp-free-shipping-progress-cart-page", "main[data-hook='CartAppDataHook.root'] [data-hook='CartItemsDataHook.root']");
    }
}

const displayFreeShippingElement = (progressElementId: string, targetSiblingSelector: string) => {
    let freeShippingProgressElement = document.getElementById(progressElementId);
    if (!freeShippingProgressElement) {
        const cartItemsElement = document.querySelector(targetSiblingSelector);
        const cartItemsContainer = cartItemsElement;
        const freeShippingElement = document.createElement("template");
        freeShippingElement.innerHTML = `
        <div
        class="mp-freeshipping-progress-bar" data-skin="standard">
            <div class="mp-freeshipping-progress-bar_text-indicator">You are  away from Free Shipping!</div>
            <div class="mp-freeshipping-progress-bar_bar-container">
            <div class="mp-freeshipping-progress-bar_bar-background"></div>
            <div class="mp-freeshipping-progress-bar_bar-foreground"></div>
            </div>
        </div>`;
        (freeShippingElement.content.firstElementChild as HTMLElement).id = progressElementId;
        cartItemsContainer?.parentElement?.insertBefore(freeShippingElement.content, cartItemsContainer);
        freeShippingProgressElement = document.getElementById(progressElementId) as HTMLElement;
        freeShippingProgressElement.id = progressElementId;
    }

    const percentageElement = freeShippingProgressElement.querySelector("." + PLUGIN_CLASS_PREFIX + "bar-foreground") as HTMLElement;
    let completionPercentage = (cartSubtotal / settings.threshold) * 100;
    if (completionPercentage > 100) {
        completionPercentage = 100;
    }
    percentageElement.style.width = completionPercentage + "%";

    let message = "";
    if (completionPercentage !== 100) {
        message = settings.progressMessage.replace("{remaining-amount}", toCurrency(settings.threshold - cartSubtotal)).replaceAll("\\&", "&");;
    }
    else {
        message = settings.completionMessage.replaceAll("\\&", "&");
    }
    const remainingAmountElement = freeShippingProgressElement.querySelector("." + PLUGIN_CLASS_PREFIX + "text-indicator") as HTMLElement;
    remainingAmountElement.innerHTML = message;
}

const displayUpsellProducts = () => {
    if (sideCartIsOpen && settings.visibleOnSideCart) {
        displayUpsellProductsElement("mp-free-shipping-progress-side-cart");
    }

    if (currentPage === "CartPage" && settings.visibleOnCartPage) {
        displayUpsellProductsElement("mp-free-shipping-progress-cart-page");
    }
}

const hideUpsellProducts = () => {
    const elements = document.querySelectorAll("." + PLUGIN_CLASS_PREFIX + "upsell-products");
    elements.forEach(e => {
        e.remove();
    })
}

const displayUpsellProductsElement = (progressElementId: string) => {
    const freeShippingProgressElement = document.getElementById(progressElementId) as HTMLElement;
    const containerWidth = freeShippingProgressElement.clientWidth;
    if (settings.displayUpsellProducts && upsellProducts.length > 0) {
        let upsellProductsElement = freeShippingProgressElement.querySelector("." + PLUGIN_CLASS_PREFIX + "upsell-products") as HTMLElement;
        if (!upsellProductsElement) {
            const upsellProductsTemplate = document.createElement("template");
            upsellProductsTemplate.innerHTML = `<div class="mp-freeshipping-progress-bar_upsell-products">
              <div class="splide">
                <div class="splide__track">
                    <ul class="splide__list">
                    </ul>
                </div>
              </div>
            </div>`
            freeShippingProgressElement.appendChild(upsellProductsTemplate.content);
            upsellProductsElement = freeShippingProgressElement.querySelector("." + PLUGIN_CLASS_PREFIX + "upsell-products") as HTMLElement;
        }
        // Clear items
        const carouselListElement = upsellProductsElement.querySelector("ul") as HTMLElement;
        while (carouselListElement.lastChild) {
            carouselListElement.removeChild(carouselListElement.lastChild);
        }
        for (let i = 0; i < upsellProducts.length; i++) {
            const upsellProductElement = document.createElement("template");
            upsellProductElement.innerHTML = `
                <li class="splide__slide">
                <div class="mp-freeshipping-progress-bar_main-img">
                    <a href="${upsellProducts[i].productPageUrl.base + upsellProducts[i].productPageUrl.path}"><img src="${upsellProducts[i].mainMedia?.thumbnail?.url as string}"></img></a>
                </div>
                <div class="mp-freeshipping-progress-bar_product-info">
                    <div class="mp-freeshipping-progress-bar_product-title"><a href="${upsellProducts[i].productPageUrl.base + upsellProducts[i].productPageUrl.path}">${upsellProducts[i].name as string}</a></div>
                    <div class="mp-freeshipping-progress-bar_product-price">${upsellProducts[i].priceData?.formatted?.discountedPrice as string}</div>
                </div>
                <div class="mp-freeshipping-progress-bar_add-to-cart-btn"><button type="button">${settings.buttonText}</button></div>
                </li>
            `;
            const btnElement = (upsellProductElement.content.querySelector("button") as HTMLElement);
            btnElement.onclick = async () => {
                try {
                    const widthBefore = btnElement.clientWidth;
                    btnElement.innerHTML = `<div class="mp-freeshipping-progress-bar_loader"></div>`;
                    btnElement.style.width = widthBefore + "px";
                    await addToCart(upsellProducts[i]._id as string);
                }
                finally {
                    btnElement.style.width = "";
                    btnElement.innerHTML = settings.buttonText;
                }
            }
            carouselListElement?.appendChild(upsellProductElement.content);
            if (i === 9) {
                break;
            }
        }
        let perPage = Math.floor(containerWidth / 300);
        if(perPage < 1){
            perPage = 1;
        }
        new Splide(`#${progressElementId} .splide`, { pagination: false, perPage: perPage }).mount();
    }
}

const toCurrency = (val: number) => {
    return new Intl.NumberFormat(navigator.language, { style: "currency", currency: cartCurrency }).format(val);
}

const registerListener = () => {
    window.wixDevelopersAnalytics.register('982732e6-d6c8-4f00-88a0-1714a946c18d',
        (eventName: string, eventParams: any) => {
            if (eventName === "PageView") {
                sideCartIsOpen = false;
                if (eventParams.pageTypeIdentifier === "ecom_side_cart") {
                    sideCartIsOpen = true;
                    getCart();
                    wixClient.ecom.onCartChange(getCart);
                }
                else if (eventParams.pageTypeIdentifier === "shopping_cart") {
                    currentPage = "CartPage";
                    getCart();
                    wixClient.ecom.onCartChange(getCart);
                }
                else {
                    currentPage = "Other";
                }
            }
        }
    );
}

const getAppInstance = async () => {
    try {
        const res = await wixClient.fetchWithAuth(`${settings.apiUrl}/app-api`);
        const data = await res.json();
        if (data.instance.isFree || new Date(data.instance.billing.expirationDate) < new Date()) {
            canFunction = false;
        }
        appInstanceChecked = true;
    }
    catch (err) {
        console.error(err);
    }
}

const wixClient = createClient({
    auth: site.auth(),
    host: site.host({ applicationId: "982732e6-d6c8-4f00-88a0-1714a946c18d" }),
    modules: { ecom, currentCart },
});

export const injectAccessTokenFunction = wixClient.auth.getAccessTokenInjector();

prepareStyle();

window.wixDevelopersAnalytics ?
    registerListener() :
    window.addEventListener('wixDevelopersAnalyticsReady', registerListener);

setTimeout(() => {
    getAppInstance();
}, 2000);
